// removed by extract-text-webpack-plugin
module.exports = {"base":"Filters_base--BjxKv","base__opened":"Filters_base__opened--3Pu5n","baseOpened":"Filters_base__opened--3Pu5n","background":"Filters_background--E_VWb","back":"Filters_back--1LGMG","container":"Filters_container--3DJYC","section":"Filters_section--2PYYU","section__bordered":"Filters_section__bordered--3ly6a","sectionBordered":"Filters_section__bordered--3ly6a","buttons":"Filters_buttons--uL_KM","button":"Filters_button--gICuk","title":"Filters_title--1YwXX","subtitle":"Filters_subtitle--1fxaI","languages":"Filters_languages--14od6"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Filters/Filters.scss
// module id = 2282
// module chunks = 11